export default __webpack_public_path__ + "static/media/nft.4a1050b6.webp";